var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgProjectStatusFin = function SvgProjectStatusFin(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 44 44",
    fill: "current",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ProjectStatusFIN_svg__a)",
    stroke: "current",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.667 5.5v7.333a1.833 1.833 0 0 0 1.833 1.834h7.333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.167 38.5H12.833a3.667 3.667 0 0 1-3.666-3.667V9.167A3.667 3.667 0 0 1 12.833 5.5h12.834l9.166 9.167v20.166a3.667 3.667 0 0 1-3.666 3.667Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m16.5 27.5 3.667 3.667 7.333-7.334"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "ProjectStatusFIN_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h44v44H0z"
  })))));
};
export default SvgProjectStatusFin;